<template>
  <div class="icons_remark">
    <dl>
      <dt><img src="./img/match_status/1.png" /></dt>
      <dd>{{ $t("matchDetail.goIn") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/2.png" /></dt>
      <dd>{{ $t("matchDetail.right") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/3.png" /></dt>
      <dd>{{ $t("matchDetail.slant") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/4.png" /></dt>
      <dd>{{ $t("fb_data.8") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/5.png" /></dt>
      <dd>{{ $t("fb_data.16") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/6.png" /></dt>
      <dd>{{ $t("fb_data.17") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/7.png" /></dt>
      <dd>{{ $t("fb_data.18") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/8.png" /></dt>
      <dd>{{ $t("fb_data.2") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/9.png" /></dt>
      <dd>{{ $t("fb_data.3") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/10.png" /></dt>
      <dd>{{ $t("fb_data.4") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/11.png" /></dt>
      <dd>{{ $t("fb_data.9") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/12.png" /></dt>
      <dd>{{ $t("fb_data.15") }}</dd>
    </dl>
    <dl>
      <dt><img src="./img/match_status/13.png" /></dt>
      <dd>VAR</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "FootballIcons",
};
</script>

<style lang="scss" scoped>
//[足球]图示说明
.icons_remark {
  clear: both;
  width: 100%;
  overflow: hidden;
  border-top: 1px solid #f0f0f0;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 0.2rem 0.45rem;
  padding-right: 0;

  dl {
    float: left;
    width: 1.2rem;
    height: 0.22rem;
    overflow: hidden;
    margin-bottom: 0.2rem;

    dt {
      float: left;
      width: 0.22rem;
      height: 100%;
      overflow: hidden;

      img {
        display: block;
        height: 100%;
        margin: 0px auto;
      }
    }

    dd {
      float: left;
      width: calc(100% - 0.22rem);
      height: 100%;
      line-height: 0.22rem;
      overflow: hidden;
      box-sizing: border-box;
      padding-left: 0.05rem;
      font-size: 0.14rem;
      color: #666;
    }
  }
}
</style>
